import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class OrgTreeNodeErpIdentifier implements ViewModel {
  public readonly friendlyTypeNameSingular = 'Org Tree Node Erp Itentifier';
  public readonly apiRoute: string = CONFIG.apiRoutes.orgTreeNodeErpIdentifier;

  orgTreeNodeId: string;
  erpIdentifier: string;
  isParentErpIdentifierUsed: boolean;
  checkParentErpIdentifier: boolean;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.erpIdentifier = data.erpIdentifier;
    this.isParentErpIdentifierUsed = data.isParentErpIdentifier;
    this.checkParentErpIdentifier = data.checkParentErpIdentifier;
  }
}
